import checkIsTicketTypeVisible from './checkIsTicketTypeVisible';

export default function getVisibleTicketTypes({ page, ticketGroup, query = {} }) {
  const visibleTicketTypes = ticketGroup.ticketTypes.filter(ticketType =>
    checkIsTicketTypeVisible({ page, ticketType, query }),
  );

  return visibleTicketTypes;
}
